import { IoClose } from 'react-icons/io5';
import { useGetCategoriesFilter } from '@framework/filters/get-categories-filter';
import { useGetKosherFilter } from '@framework/filters/get-kosher-filter';
import { useTranslation } from '@i18n/client';
import { useFetchManufacturersFilter } from '@framework/filters/get-manufacturers-filter';
import { getFilterNameForLanguage } from '@framework/types';

interface Props {
  lang: string;
  itemKey: string;
  itemValue: string;
  onClick: () => void;
}

export const FilteredItem = ({ lang, itemKey, itemValue, onClick }: Props) => {
  const { data: categories } = useGetCategoriesFilter();
  const { data: kosher } = useGetKosherFilter();
  const { data: manufacturersItems } = useFetchManufacturersFilter();
  const { t } = useTranslation(lang);

  const getName = () => {
    switch (itemKey) {
      case 'q':
        return `Search: ${itemValue}`;
      case 'kosher_pesach':
        return t('common:text-show-only-kosher_pesach-product');
      case 'sort_by':
        return `sort: ${itemValue.replace('-', ' ')}`;
      case 'category':
        return `category: ${getFilterNameForLanguage(
          categories
            ?.flatMap((c) => [c, ...c.children])
            ?.find((c) => c.id == itemValue),
          lang,
        )}`;
      case 'kosher':
        return `Kosher: ${getFilterNameForLanguage(
          kosher?.find((c) => c.slug.toLowerCase() == itemValue.toLowerCase()),
          lang,
        )}`;
      case 'manufacturer':
        return `Manufacturer: ${getFilterNameForLanguage(
          manufacturersItems?.find(
            (c) => c.slug.toLowerCase() == itemValue.toLowerCase(),
          ),
          lang,
        )}`;
      case 'hide_out_of_stock':
        return t('common:text-hide-out-of-stock');
      default:
        return itemValue;
    }
  };

  return (
    <div
      className="group flex shrink-0 m-1 items-center border border-border-base rounded-lg text-13px px-2.5 py-1.5 capitalize text-brand-dark cursor-pointer transition duration-200 ease-in-out hover:border-brand"
      onClick={onClick}
    >
      {getName()}
      <IoClose className="text-sm text-body ltr:ml-2 rtl:mr-2 shrink-0 ltr:-mr-0.5 rtl:-ml-0.5 mt-0.5 transition duration-200 ease-in-out group-hover:text-heading" />
    </div>
  );
};
